import Footer from "./Footer";
import Icon from "@/components/icons";
import ProductSearchListItem from "./ProductSearchListItem";
import { ProductSearchListItemProps } from "./ProductSearchListItem";
import MainContent from "./MainContent";
import { ElementType, FormatSubType } from "@/constants/tagular/main";
import EventLink from "@/components/Link/EventLink/EventLink";

export type Category = {
  name: string;
  count: number;
  categoryUrl: string;
};

type AfterStateProps = {
  categories?: Category[];
  resultItems: ProductSearchListItemProps[];
  query: string;
  location?: string;
  maxProducts?: number;
  maxCategories?: number;
};

const AfterState = ({
  categories,
  resultItems,
  query,
  location = "embedded-search",
  maxProducts = 5,
  maxCategories = 2,
}: AfterStateProps) => {
  const categoriesToShow = categories?.slice(0, maxCategories) || [];
  const productsToShow =
    resultItems.slice(0, Math.max(0, maxProducts - categoriesToShow.length)) ||
    [];
  return (
    <MainContent>
      <div className="w-full flex flex-col gap-4">
        {categoriesToShow.length > 0 && (
          <div className="border-b border-putty-400 px-4 mt-4">
            <div className="flex flex-row items-center gap-1">
              <Icon
                type="book-open"
                svgProps={{ width: 24, height: 24 }}
                pathProps={{ fill: "#B4B1A8" }}
              />
              <span className="elm-p2 text-putty-600 font-bold">
                CATEGORIES
              </span>
            </div>
            <ul className="list-none p-0 my-0">
              {categoriesToShow.map((item, index) => (
                <li key={item.name} className="m-0 py-2 flex justify-between">
                  <EventLink
                    href={item.categoryUrl}
                    element_type={ElementType.Entry}
                    html_id="search-result"
                    location={location}
                    text={item.name}
                    visible_text={`${item.name} (${item.count})`}
                    name={item.name}
                    position={(index + 1).toString()}
                    class_name="elm-p2 text-primary-500 font-bold"
                  />
                </li>
              ))}
            </ul>
          </div>
        )}
        <div className="border-b border-putty-400 px-4">
          <div className="flex flex-row items-center gap-1">
            <Icon
              type="school"
              svgProps={{ width: 24, height: 24 }}
              pathProps={{ fill: "#B4B1A8" }}
            />
            <span className="elm-p2 text-putty-600 font-bold">
              COURSES AND PROGRAMS
            </span>
          </div>
          <ul className="list-none !p-0 my-0">
            {productsToShow.map((item, index) => (
              <li key={item.id} className="m-0 py-2">
                <ProductSearchListItem
                  id={item.id}
                  productName={item.productName}
                  productCategory={item.productCategory}
                  partner={item.partner}
                  partnerLogoUrl={item.partnerLogoUrl}
                  subtype={FormatSubType.SearchResult}
                  viewedSince={item.viewedSince}
                  timeToComplete={item.timeToComplete}
                  href={item.href}
                  index={index}
                  location={location}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
      <Footer>
        {/* Maybe the styling of this div goes in the footer if it's consistent with all states */}
        <span className="w-full h-[46px] flex items-center justify-center elm-p2 text-center text-primary-500 text-balance font-bold">
          Press Enter to see all results for &quot;{query}&quot;
        </span>
      </Footer>
    </MainContent>
  );
};

export default AfterState;
